import { SCHEDULER_OFFLINE_ENABLED } from '../../core/services/schedulerOfflineStore';
export async function registerSchedulerOfflineShell(): Promise<void> {
  if (!SCHEDULER_OFFLINE_ENABLED || !('serviceWorker' in navigator) || !window.isSecureContext) return;
  try { await navigator.serviceWorker.register('/scheduler-offline-sw.js', { scope:'/', updateViaCache:'none' }); }
  catch { /* Data queues remain durable. Failed shell download does not masquerade as offline readiness. */ }
}
